/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, address: NonNullable<unknown> }} Footer_RegisteredInputs */



/**
* | output |
* | --- |
* | "Registered in England and Wales, No. {number}. Registered office: {address}." |
*
* @param {Footer_RegisteredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const footer_registered = /** @type {((inputs: Footer_RegisteredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_RegisteredInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`在英格兰和威尔士注册，公司编号 ${i?.number}。注册办事处：${i?.address}。`)
	return /** @type {LocalizedString} */ (`Registered in England and Wales, No. ${i?.number}. Registered office: ${i?.address}.`)
});